module.exports = __webpack_public_path__ + "static/media/unavailable.860ab0ff.png";